// @ts-check
import React from "react"
import { Image } from "primereact/image"
import Button from "../../../../../components/atoms/Button.atom"
import ProgressBar from "../../../../../components/atoms/misc/ProgressBar.atom"
import { clsx } from "../../../../../utils/strings.utils"
import { isPdfMediaType } from "./estimationAgentAttachments.constants"

/** @type {import("react").ComponentType<Record<string, unknown>>} */
const ProgressBarLoose = ProgressBar

/**
 * @typedef {object} ComposerAttachmentItem
 * @property {string} id
 * @property {'uploading' | 'ready' | 'error'} phase
 * @property {string} localName
 * @property {string} mediaType
 * @property {string} [url]
 * @property {string} [error]
 */

/**
 * @param {{
 *   items: ComposerAttachmentItem[];
 *   onRemove: (id: string) => void;
 * }} props
 */
export default function ComposerAttachmentStrip({ items, onRemove }) {
  if (items.length === 0) return null

  return (
    <div className="estimation-agent-quick-v3__composer-attachments">
      {items.map((item) => {
        const isPdf = isPdfMediaType(item.mediaType)
        const uploading = item.phase === "uploading"
        const failed = item.phase === "error"

        if (isPdf) {
          return (
            <div
              key={item.id}
              className={clsx(
                "estimation-agent-quick-v3__file-tile",
                "estimation-agent-quick-v3__file-tile--pdf",
                failed && "estimation-agent-quick-v3__file-tile--error"
              )}
            >
              <div className="estimation-agent-quick-v3__file-tile-pdf-head">
                <span className="estimation-agent-quick-v3__file-tile-name">
                  {item.localName}
                </span>
                <Button
                  type="button"
                  icon="pi pi-times"
                  className="p-button-text p-button-sm estimation-agent-quick-v3__file-tile-remove"
                  onClick={() => onRemove(item.id)}
                  aria-label="Quitar archivo"
                />
              </div>
              {uploading ?
                <div className="estimation-agent-quick-v3__file-tile-progress">
                  <ProgressBarLoose mode="indeterminate" />
                </div>
              : null}
              {!uploading && !failed ?
                <button
                  type="button"
                  className="estimation-agent-quick-v3__file-tile-pdf-foot"
                  onClick={() => {
                    if (item.url) {
                      window.open(item.url, "_blank", "noopener,noreferrer")
                    }
                  }}
                  disabled={!item.url}
                >
                  <i
                    className="pi pi-file-pdf estimation-agent-quick-v3__file-tile-pdf-icon"
                    aria-hidden
                  />
                  <span>PDF</span>
                </button>
              : null}
              {failed && item.error ?
                <span className="estimation-agent-quick-v3__file-tile-err">
                  {item.error}
                </span>
              : null}
            </div>
          )
        }

        return (
          <div
            key={item.id}
            className={clsx(
              "estimation-agent-quick-v3__file-tile",
              "estimation-agent-quick-v3__file-tile--image",
              failed && "estimation-agent-quick-v3__file-tile--error"
            )}
          >
            {uploading ?
              <div className="estimation-agent-quick-v3__file-tile-image-loading">
                <div className="estimation-agent-quick-v3__file-tile-progress">
                  <ProgressBarLoose mode="indeterminate" />
                </div>
              </div>
            : item.url ?
              <div className="estimation-agent-quick-v3__file-tile-image-wrap">
                <Image
                  src={item.url}
                  alt={item.localName}
                  preview
                  imageClassName="estimation-agent-quick-v3__file-tile-img"
                />
              </div>
            : null}
            <Button
              type="button"
              icon="pi pi-times"
              className="p-button-text p-button-sm estimation-agent-quick-v3__file-tile-remove estimation-agent-quick-v3__file-tile-remove--float"
              onClick={() => onRemove(item.id)}
              aria-label="Quitar imagen"
            />
            {failed && item.error ?
              <span className="estimation-agent-quick-v3__file-tile-err">
                {item.error}
              </span>
            : null}
          </div>
        )
      })}
    </div>
  )
}
